// extracted by mini-css-extract-plugin
module.exports = {"root":"news-module--root--qHw3W"};